import { Fade, TableBody, TableCell, TableRow } from '@mui/material';
import { Fragment } from 'react';
import EmptyState from '../../common/EmptyState';

const CustomizableListTableBody = ({
  results,
  rowRenderer,
  emptyState,
  columnCount,
}) => {
  const hasResults = Array.isArray(results) && results.length > 0;

  return (
    <Fade in={true} timeout={400} unmountOnExit={true}>
      <TableBody>
        {hasResults ? (
          // Wrap each rendered row in a keyed Fragment so React's array-key
          // validator is satisfied regardless of whether the rowRenderer
          // attaches a key itself. We key by index (stable per page) so
          // duplicate ids in the result set don't trigger React's "two
          // children with the same key" warning.
          results.map((item, idx) => (
            <Fragment key={`row-${idx}`}>{rowRenderer(item)}</Fragment>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={columnCount || 1} sx={{ borderBottom: 'none', p: 0 }}>
              {emptyState || (
                <EmptyState
                  title="No records to show"
                  description="There are no items matching the current view."
                />
              )}
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Fade>
  );
};

export default CustomizableListTableBody;
